module.exports = __webpack_public_path__ + "fonts/Abel-Regular.75e89759.ttf";